@if (game$ | async) {
  <router-outlet></router-outlet>
}
